import type { WaitlistVariant } from "@/components/WaitlistContext";
import { getUtmParams } from "@/lib/utm";

const WAITLIST_ENDPOINT: string | null = null;

interface SubmitParams {
  email: string;
  message: string;
  variant: WaitlistVariant;
}

export async function submitWaitlist({ email, message, variant }: SubmitParams): Promise<void> {
  const utm = getUtmParams();
  const payload = { email, message, variant, timestamp: new Date().toISOString(), ...utm };

  if (WAITLIST_ENDPOINT) {
    await fetch(WAITLIST_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
  } else {
    const existing = JSON.parse(localStorage.getItem("conduit_waitlist") || "[]");
    existing.push(payload);
    localStorage.setItem("conduit_waitlist", JSON.stringify(existing));
  }
}
